<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { setStatistics } from '@/database'
export default {
  computed: {
    ...mapState(['chatControl'])
  },
  mounted() {
    setTimeout(() => {
      this.chatControl.setUserInfo(this.$route.query)
    }, 1000)
    setStatistics()
  }
}
</script>

<style lang="stylus">
@import "./assets/style/animate.styl";
@import "./assets/style/index.styl";
</style>



// WEBPACK FOOTER //
// src/App.vue